import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { Link } from '@material-ui/core';

type FormGroupProps = {
    children: React.ReactNode,
    actionText?: string,
    actionClick?: () => void,
    title?: string,
    className?: string,
    style?: React.CSSProperties,
    actionElement?: React.ReactNode,
};

FormGroup.defaultProps = {
    actionText: '',
    actionClick: () => {},
    title: '',
    className: '',
    style: {},
    actionElement: null,
};

const useStyle = makeStyles((theme: Theme) => createStyles({
    root: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        paddingBottom: theme.spacing(2),
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
        },
        '& .MuiFormControlLabel-root': {
            margin: theme.spacing(1),
        },
        '& .MuiButton-root': {
            margin: theme.spacing(1),
        },
        '& .MuiLink-root': {
            margin: theme.spacing(1),
        },
        '& .MuiFormControl-root': {
            margin: theme.spacing(1),
        },
    },
    title: {
        margin: theme.spacing(1),
        fontSize: theme.typography.h5.fontSize,
        color: '#001724',
        fontWeight: 700,
        alignSelf: 'flex-end',
        whiteSpace: 'nowrap',
    },
    top: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    action: {
        margin: theme.spacing(1),
        alignItems: 'center',
    },
}));

function FormGroup(props: FormGroupProps): React.ReactElement {
    const {
        children,
        title,
        actionText,
        actionClick,
        className,
        style = FormGroup.defaultProps.style,
        actionElement = FormGroup.defaultProps.actionElement,
    } = props;
    const classes = useStyle();

    function renderTitle() {
        return (
            <div className={classes.title}>{title}</div>
        );
    }

    function renderAction() {
        return (
            <Link className={classes.action} onClick={actionClick}>{actionText}</Link>
        );
    }

    return (
        <form className={classes.root} noValidate autoComplete="off">
            <div className={classes.top}>
                {title ? (renderTitle()) : null}
                {actionElement || null}
                {!actionElement && actionText ? (renderAction()) : null}
            </div>
            {children}
        </form>
    );
}

export { FormGroup };
